{
  "language": {
    "title": "Wählen Sie Ihre Sprache",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Hallo, wie können wir Ihnen helfen?",
    "checkIn": "Einchecken",
    "independentManualCheckIn": "Ohne Termin",
    "integratedManualCheckIn": "Manuell einchecken",
    "checkOut": "Auschecken",
    "manualCheckOut": "Manuell auschecken",
    "parcelDelivery": "Paketlieferung",
    "foodDelivery": "Essenslieferung",
    "callReception": "Rezeption anrufen",
    "overview": "Übersicht",
    "unavailable": "Die Rezeption ist derzeit nicht verfügbar."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Wählen Sie eine Option zum Einchecken",
        "manual": "Manuell einchecken",
        "code": "Mit PIN oder QR-Code einchecken",
        "code-no-qr": "Mit PIN-Code einchecken"
      },
      "checkout": {
        "title": "Wählen Sie eine Option zum Auschecken",
        "manual": "Mit Namen auschecken",
        "code": "Mit PIN oder QR-Code auschecken",
        "code-no-qr": "Mit PIN-Code auschecken"
      }
    },
    "title": "Sie können nun Ihren QR-Code scannen oder Ihren PIN-Code eingeben.",
    "orText": "Oder",
    "qrScanner": {
      "checkin": {
        "title": "Wählen Sie eine Option zum Einchecken"
      },
      "checkout": {
        "title": "Wählen Sie eine Option zum Auschecken"
      },
      "btn": "QR-Code scannen"
    },
    "hidScanner": {
      "title": "Halten Sie den QR-Code an den Scanner unten oder geben Sie Ihren PIN-Code ein"
    },
    "pinOnly": {
      "title": "Bitte geben Sie Ihren PIN-Code ein"
    },
    "pinCode": "Geben Sie Ihren PIN-Code ein",
    "manually": {
      "checkin": "Haben Sie keinen Anmeldecode?"
    },
    "status": {
      "idle": {
        "title": "Ihr Code wird gescannt.",
        "message": "Bitte warten...",
        "nfc": {
          "title": "Ihr Tag wird gescannt.",
          "message": "Bitte warten..."
        }
      },
      "loading": {
        "title": "Ihr Code wird gescannt.",
        "message": "Bitte warten...",
        "nfc": {
          "title": "Ihr Tag wird gescannt.",
          "message": "Bitte warten..."
        }
      },
      "error": {
        "title": "Ihr Code ist ungültig.",
        "message": "Bitte versuchen Sie es erneut!",
        "nfc": {
          "title": "Ihr Tag ist ungültig.",
          "message": "Bitte versuchen Sie es erneut!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Sie sind etwas zu früh",
            "message": "Ihr Code ist gültig ab {{validFromTime}}. Das Meeting beginnt um {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Dieser Code ist abgelaufen",
            "message": "Das Meeting endete um {{meetingEndTime}}. Ihr Code war gültig bis {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Sie haben sich erfolgreich eingecheckt.",
            "message": "Vielen Dank."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Sie haben sich erfolgreich eingecheckt.",
              "message": "Vielen Dank."
            },
            "email-sms": {
              "title": "Sie haben sich erfolgreich eingecheckt.",
              "message": "Ihre Kontaktperson wurde benachrichtigt."
            },
            "call-ping": {
              "title": "Sie haben sich erfolgreich eingecheckt.",
              "message": "Wir werden nun einen Telefonanruf mit Ihrer Kontaktperson herstellen."
            },
            "teams-call": {
              "title": "Sie haben sich erfolgreich eingecheckt.",
              "message": "Wir werden nun einen Microsoft Teams-Anruf mit Ihrer Kontaktperson herstellen."
            },
            "badge": {
              "title": "Vielen Dank für das Einchecken, Ihr Ausweis wird gedruckt.",
              "message": ""
            },
            "video-call": {
              "title": "Sie haben sich erfolgreich eingecheckt.",
              "message": "Ihr Videoanruf mit der Kontaktperson wird eingerichtet."
            }
          },
          "Employee": {
            "title": "Sie haben sich erfolgreich eingecheckt.",
            "message": "Vielen Dank.",
            "badge": {
              "title": "Vielen Dank für das Einchecken, Ihr Ausweis wird gedruckt.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Sie haben sich erfolgreich eingecheckt.",
            "message": "Vielen Dank.",
            "badge": {
              "title": "Vielen Dank für das Einchecken, Ihr Ausweis wird gedruckt.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Sie haben sich erfolgreich ausgecheckt.<br/>",
            "message": "Bis bald."
          },
          "MeetingAttendee": {
            "title": "Sie haben sich erfolgreich ausgecheckt.",
            "message": "Bis bald."
          },
          "Employee": {
            "title": "Sie haben sich erfolgreich ausgecheckt.",
            "message": "Bis bald."
          },
          "Visitor": {
            "title": "Sie haben sich erfolgreich ausgecheckt.",
            "message": "Bis bald."
          },
          "access": {
            "title": "Sie haben sich erfolgreich ausgecheckt.",
            "message": "Sie können nun die Tür öffnen."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Noch ein paar Angaben vor dem Check-in",
    "subtitle": "Mit * markierte Felder sind erforderlich",
    "btn": "Einchecken",
    "placeholder": {
      "other": "Andere...",
      "otherInput": "Geben Sie Ihre Option ein"
    },
    "error": {
      "required": "Dieses Feld ist erforderlich",
      "email": "Ungültige E-Mail-Adresse",
      "phone": "Ungültige Telefonnummer"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Bitte ausfüllen.",
      "documentScanner": "Achten Sie beim Einlegen Ihres Personalausweises auf Folgendes:"
    },
    "subtitle": {
      "default": "Hinweis - jedes Feld * ist erforderlich",
      "documentScanner": [
        {
          "parts": [
            { "text": "Die ", "bold": false },
            { "text": "Seite mit den <<< >>>-Zeichen (MRZ) ", "bold": true },
            { "text": "muss ", "bold": false },
            { "text": "zum Kiosk / Scanner gerichtet sein.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Halten Sie die Karte still ", "bold": false },
            {
              "text": "bis die Felder automatisch ausgefüllt sind.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Keine Option",
    "btn": "Einchecken",
    "placeholder": {
      "name": "Ihr Name *",
      "email": "Ihre E-Mail *",
      "phone": "Mobilnummer",
      "contactName": "Ihre Kontaktperson*",
      "other": "Andere..."
    },
    "error": {
      "required": "Sie haben dieses Feld nicht ausgefüllt",
      "name": "Ungültiger Name",
      "email": "Ungültige E-Mail-Adresse",
      "phone": "Ungültige Mobilnummer"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Bitte warten...",
          "message": "Ihre Registrierung wird bearbeitet."
        },
        "contact": {
          "title": "Bitte warten...",
          "message": "Ihre Kontaktperson wird benachrichtigt."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Bitte warten...",
          "message": "Ihre Registrierung wird bearbeitet."
        },
        "contact": {
          "title": "Bitte warten...",
          "message": "Ihre Kontaktperson wird benachrichtigt."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Sie haben sich erfolgreich eingecheckt.",
          "message": "Vielen Dank."
        },
        "email-sms": {
          "title": "Sie haben sich erfolgreich eingecheckt.",
          "message": "Ihre Kontaktperson wurde benachrichtigt."
        },
        "call-ping": {
          "title": "Sie haben sich erfolgreich eingecheckt.",
          "message": "Wir werden nun einen Telefonanruf mit Ihrer Kontaktperson herstellen."
        },
        "teams-call": {
          "title": "Sie haben sich erfolgreich eingecheckt.",
          "message": "Wir werden nun einen Microsoft Teams-Anruf mit Ihrer Kontaktperson herstellen."
        },
        "badge": {
          "title": "Vielen Dank für das Einchecken, Ihr Ausweis wird gedruckt.",
          "message": ""
        },
        "video-call": {
          "title": "Sie haben sich erfolgreich eingecheckt.",
          "message": "Ihr Videoanruf mit der Kontaktperson wird eingerichtet."
        }
      },
      "error": {
        "title": "Etwas ist schiefgelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Dokument ungültig",
        "message": "Das Dokument konnte nicht verifiziert werden oder ist abgelaufen. Bitte geben Sie Ihre Daten manuell ein."
      }
    }
  },
  "manualCheckout": {
    "title": "Geben Sie Ihren Namen ein, um auszuchecken",
    "btn": "Auschecken",
    "form": {
      "placeholder": {
        "name": "Ihr vollständiger Name *"
      },
      "loading": "Lädt...",
      "noOptions": "Keine Optionen"
    },
    "error": {
      "required": "Sie haben dieses Feld nicht ausgefüllt",
      "name": "Ungültiger Name"
    },
    "status": {
      "idle": {
        "title": "Wir verarbeiten Ihre Informationen.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir verarbeiten Ihre Informationen.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Sie haben sich erfolgreich ausgecheckt.",
        "message": "Vielen Dank und einen schönen Tag."
      },
      "successAccess": {
        "title": "Sie haben sich erfolgreich ausgecheckt.",
        "message": "Sie können nun die Tür öffnen."
      },
      "error": {
        "title": "Beim Auschecken ist ein Fehler aufgetreten.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Möchten Sie Ihre Kontaktperson benachrichtigen?",
      "email-sms": "Wir haben eine E-Mail/SMS an Ihre Kontaktperson gesendet.<br/>Möchten Sie zusätzlich einen Anruf mit ihnen führen?"
    },
    "callBtn": "Anrufen",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Videoanruf",
    "teamsCallBtn": "Teams-Anruf",
    "teamsMessageBtn": "Teams-Nachricht",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Abbrechen",
    "cancelBtn": "Anruf abbrechen",
    "status": {
      "connecting": {
        "title": "Anruf wird hergestellt.<br/>Bitte warten...",
        "message": ""
      },
      "ringing": {
        "title": "Ihre Kontaktperson wird angerufen<br/>Bitte warten...",
        "message": ""
      },
      "ringingReception": {
        "title": "Anruf gestartet...",
        "message": ""
      },
      "open": {
        "title": "Anruf läuft.",
        "message": ""
      },
      "close": {
        "title": "Anruf beendet.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Anruf beendet.<br/>Sie können nun die Tür öffnen.",
        "message": ""
      },
      "closeReception": {
        "title": "Anruf ist beendet.",
        "message": ""
      },
      "error": {
        "title": "Anruf konnte nicht hergestellt werden.<br/>Erneut anrufen?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "SMS wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Vielen Dank!"
      },
      "successAccess": {
        "title": "SMS wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Sie können nun die Tür öffnen."
      },
      "error": {
        "title": "SMS nicht gesendet.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "videoCall": {
    "title": "Videoanruf",
    "endCall": "Anruf beenden",
    "status": {
      "idle": {
        "title": "Wir erstellen einen Videoraum.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir erstellen einen Videoraum.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Der Videoraum wurde erfolgreich erstellt.",
        "message": "Raum wird betreten..."
      },
      "error": {
        "title": "Der Videoraum wurde nicht erfolgreich erstellt.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "teamsCall": {
    "title": "Teams-Anruf",
    "controls": {
      "startCall": "Anruf starten",
      "endCall": "Verlassen",
      "camera": "Kamera",
      "cameraOff": "Kamera aus",
      "mic": "Mikrofon",
      "micOff": "Mikrofon aus",
      "ringing": "Klingelt...",
      "noAnswer": "Niemand hat den Anruf beantwortet."
    },
    "status": {
      "connecting": {
        "title": "Anruf wird hergestellt.<br/>Bitte warten...",
        "message": ""
      },
      "ringing": {
        "title": "Ihre Kontaktperson wird angerufen<br/>Bitte warten...",
        "message": ""
      },
      "connected": {
        "title": "Anruf wird hergestellt",
        "message": ""
      },
      "disconnected": {
        "title": "Anruf beendet.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Anruf beendet.<br/>Sie können nun die Tür öffnen.",
        "message": ""
      },
      "error": {
        "title": "Anruf konnte nicht hergestellt werden.<br/>Bitte versuchen Sie es erneut",
        "message": ""
      },
      "noAnswer": {
        "title": "Niemand hat den Anruf beantwortet.<br/>Bitte versuchen Sie es erneut.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Vielen Dank!"
      },
      "successAccess": {
        "title": "Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Sie können nun die Tür öffnen."
      },
      "error": {
        "title": "Nachricht nicht gesendet.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "loading": {
        "title": "Wir benachrichtigen Ihre Kontaktperson.",
        "message": "Bitte warten..."
      },
      "success": {
        "title": "Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Vielen Dank!"
      },
      "successAccess": {
        "title": "Nachricht wurde gesendet. Der Kontakt wurde benachrichtigt.",
        "message": "Sie können nun die Tür öffnen."
      },
      "error": {
        "title": "Nachricht nicht gesendet.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "packageDelivery": {
    "title": "Wie schön, dass Sie ein Paket liefern!",
    "subtitle": "Wählen Sie den Empfänger aus und benachrichtigen Sie ihn",
    "subtitle1": "Drücken Sie die Schaltfläche unten, um uns mitzuteilen, dass Sie hier sind!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Für wen ist das Paket"
      },
      "error": {
        "contact": {
          "required": "Sie haben dieses Feld nicht ausgefüllt"
        }
      }
    },
    "button": {
      "submit": "Benachrichtigen"
    },
    "status": {
      "loading": {
        "title": "Wir benachrichtigen die Kontaktperson.",
        "message": "Bitte warten..."
      },
      "success": {
        "no-email-sms": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": ""
        },
        "email-sms": {
          "title": "Die Kontaktperson wurde benachrichtigt.",
          "message": "Vielen Dank für Ihre Lieferung!"
        },
        "call-ping": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Eine Telefonverbindung zur Kontaktperson wird nun hergestellt."
        },
        "teams-call": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Ein Microsoft Teams-Anruf zu Ihrer Kontaktperson wird nun getätigt."
        },
        "video-call": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Ihr Videoanruf mit der Kontaktperson wird eingerichtet."
        }
      },
      "error": {
        "title": "Etwas ist schiefgelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "foodDelivery": {
    "title": "Wie schön, dass Sie Essen liefern!",
    "subtitle": "Wählen Sie den Empfänger aus und benachrichtigen Sie ihn",
    "subtitle1": "Drücken Sie die Schaltfläche unten, um uns mitzuteilen, dass Sie hier sind!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Für wen ist das Essen"
      },
      "error": {
        "contact": {
          "required": "Sie haben dieses Feld nicht ausgefüllt"
        }
      }
    },
    "button": {
      "submit": "Benachrichtigen"
    },
    "status": {
      "loading": {
        "title": "Wir benachrichtigen den Kontakt.",
        "message": "Bitte warten!"
      },
      "success": {
        "no-email-sms": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": ""
        },
        "email-sms": {
          "title": "Der Kontakt wurde benachrichtigt.",
          "message": "Vielen Dank für Ihre Lieferung!"
        },
        "call-ping": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Eine Telefonverbindung zu Ihrer Kontaktperson wird nun hergestellt."
        },
        "teams-call": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Ein Microsoft Teams-Anruf zu Ihrer Kontaktperson wird nun getätigt."
        },
        "video-call": {
          "title": "Vielen Dank für Ihre Lieferung!",
          "message": "Ihr Videoanruf mit der Kontaktperson wird eingerichtet."
        }
      },
      "error": {
        "title": "Etwas ist schiefgelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Bitte scannen Sie Ihren QR-Code",
    "subtitle": "Richten Sie den QR-Code innerhalb der roten Ecken aus und halten Sie Ihr Telefon ruhig.",
    "error": "Ungültiges QR-Code-Format",
    "unknownError": "Unbekannter Fehler beim Scannen aufgetreten"
  },
  "common": {
    "backBtn": "Zurück"
  },
  "previewPDF": {
    "page": {
      "of": "von",
      "previous": "Vorherige",
      "next": "Nächste"
    },
    "button": {
      "cancel": "Abbrechen",
      "accept": "Akzeptieren",
      "next": "Nächste"
    },
    "title": {
      "consent": "Einverständnis erforderlich"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "Die digitale Rezeption ist derzeit offline und kann nicht verwendet werden, die Internetverbindung muss überprüft werden!",
    "check": "Sind Sie ein Besucher und möchten Sie direkt mit einem Mitarbeiter sprechen? Bitte rufen Sie {{receptionistPhone}} an"
  },
  "overview": {
    "title": "Geben Sie den Code ein, um die Übersicht zu öffnen!",
    "noUsers": "Keine Registrierungen",
    "status": {
      "success": {
        "title": "Der Code ist gültig.",
        "message": ""
      },
      "error": {
        "title": "Der Code ist ungültig.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Bitte warten...",
        "message": ""
      },
      "success": {
        "title": "Erfolgreich ausgecheckt.",
        "message": ""
      },
      "error": {
        "title": "Etwas ist schiefgelaufen.",
        "message": "Bitte versuchen Sie es erneut!"
      }
    },
    "listTitle": "Liste der Personen, die heute eingecheckt, aber nicht ausgecheckt haben",
    "page": "Seite ",
    "table": {
      "head": {
        "fullName": "Name",
        "type": "Typ",
        "checkedinAt": "Eingecheckt um",
        "host": "Gastgeber"
      },
      "type": {
        "Package": "Paketlieferung",
        "Food": "Essenslieferung",
        "Visitor": "Besucher",
        "MeetingAttendee": "Eingeladener Besucher",
        "Employee": "Mitarbeiter",
        "Guest": "Besucher"
      }
    },
    "confirmModal": {
      "title": "Sind Sie sicher, dass Sie {{fullName}} auschecken möchten?",
      "cancel": "Abbrechen",
      "checkout": "Auschecken"
    }
  },
  "wifi": {
    "title": "Mit dem Wi-Fi-Netzwerk verbinden"
  },
  "door": {
    "external": {
      "title": "Tür wird geöffnet",
      "subtitle": "Die Tür wird in Kürze geöffnet. Bitte warten..."
    },
    "control": {
      "title": "Sie können nun die Tür öffnen",
      "subtitle": "Bitte drücken Sie die Schaltfläche unten!",
      "openBtn": "Tür öffnen"
    },
    "status": {
      "success": {
        "title": "Die Tür wurde geöffnet",
        "message": ""
      },
      "error": {
        "title": "Etwas ist schiefgelaufen",
        "message": "Bitte kontaktieren Sie Ihre Kontaktperson, um die Tür zu öffnen."
      },
      "loading": {
        "title": "Die Tür öffnet sich...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Möchten Sie im Rahmen Ihres Check-in-Prozesses ein Foto machen?",
    "required": {
      "title": "Fotoverifizierung erforderlich!",
      "instructions": "Bitte stellen Sie sich vor die Kamera und befolgen Sie die Anweisungen auf dem Bildschirm.",
      "securityNotice": "Zu Sicherheits- und Verifizierungszwecken ist beim Check-in ein Foto erforderlich.",
      "privacyInfo": "Wir respektieren Ihre Privatsphäre. Ihre Daten werden sicher gespeichert und nur zur Identifikation verwendet.",
      "closingMessage": "Vielen Dank für Ihre Zusammenarbeit."
    },
    "optional": {
      "title": "Möchten Sie im Rahmen Ihres Check-in-Prozesses ein Foto machen?",
      "instructions": "",
      "securityNotice": "Ein Foto kann helfen, die Identifikation zu vereinfachen und die Sicherheit zu erhöhen.",
      "privacyInfo": "Wir respektieren Ihre Privatsphäre. Dieser Schritt ist optional und Ihre Daten werden sicher behandelt.",
      "closingMessage": "Sie können diesen Schritt überspringen, wenn Sie möchten."
    },
    "subtitle": "Bitte positionieren Sie sich innerhalb des Rahmens und bleiben Sie für das beste Ergebnis ruhig",
    "button": {
      "cancel": "Abbrechen",
      "accept": "Akzeptieren",
      "skip": "Überspringen",
      "next": "Nächste",
      "recapture": "Foto erneut aufnehmen",
      "continue": "Weiter"
    },
    "error": "Beim Aufnehmen des Fotos ist ein Fehler aufgetreten. Der Check-in-Prozess wird ohne das Foto fortgesetzt."
  },
  "wayfinding": {
    "title": "Wohin möchten Sie gehen?"
  },
  "callingMenu": {
    "title": "Anrufmenü"
  },
  "bell": {
    "status": {
      "success": {
        "title": "Die Klingel läutet",
        "message": "Jemand kommt gleich."
      },
      "error": {
        "title": "Etwas ist schiefgelaufen",
        "message": "Bitte versuchen Sie es erneut"
      },
      "loading": {
        "title": "Verbinden...",
        "message": "Bitte warten"
      }
    }
  },
  "access": {
    "control": {
      "title": "Sie können nun die Tür öffnen",
      "subtitle": "Bitte drücken Sie die Schaltfläche unten.",
      "titleAuto": "Automatischer Türzugang",
      "subtitleAuto": "Die Tür wird automatisch für Sie geöffnet",
      "openBtn": "Öffnen"
    },
    "status": {
      "success": {
        "title": "Die Tür wurde geöffnet",
        "message": ""
      },
      "error": {
        "title": "Etwas ist schiefgelaufen",
        "message": "Bitte kontaktieren Sie Ihre Kontaktperson, um die Tür zu öffnen."
      },
      "loading": {
        "title": "Die Tür öffnet sich...",
        "message": ""
      }
    }
  }
}
